export const DEFAULT_HASH = 'default'

/**
 * Build a unique hash for that request (usually for parameters)
 * * make sure a "default hash" is always returned
 *
 * @param {*} request
 * @returns
 */
function hashRequest (request) {
  if (typeof request === 'undefined' || typeof request === 'string') return request || DEFAULT_HASH
  if (typeof request === 'object' && Object.keys(request).length <= 0) return DEFAULT_HASH

  return JSON.stringify(request)
}

export default hashRequest
